export async function checkForUpdate(currentVersion: string): Promise<boolean> {
  try {
    const res = await fetch("/meta.json", { cache: "no-store" })
    if (!res.ok) return false
    const { version } = await res.json()
    return version !== currentVersion
  } catch {
    return false
  }
}
